<template>
    <ClientSummary
        v-if="!isError.hasError && !isLoading"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.totalUpdate"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError && !isLoading">
        <header>
            <v-card-title>Información del Crédito</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_information">
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-basket"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">Clasificación del Títular</div>
                    <div class="data_info">{{ dataManagementInformation.generalInformation.producto }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-clock-alert"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">{{ ui.managements.pago.atraso_max }}</div>
                    <div class="data_info">{{ dataManagementInformation.paymentInformation.atraso_max }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-hand-coin"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">{{ ui.managements.pago.saldo }}</div>
                    <div class="data_info">{{ dataManagementInformation.paymentInformation.saldo }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-clock-time-eleven"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">Moratorios</div>
                    <div class="data_info">{{ dataManagementInformation.paymentInformation.moratorios }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-calendar-today"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">Día de Pago</div>
                    <div class="data_info">{{ dataManagementInformation.paymentInformation.dia_de_pago }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-cash-clock"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">Saldo Final</div>
                    <div class="data_info">{{ dataManagementInformation.paymentInformation.total }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-clipboard-text-clock"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">{{ ui.managements.pago.fecha_pago_ultimo }}</div>
                    <div class="data_info">{{ dataManagementInformation.paymentInformation.fecha_pago_ultimo }}</div>
                </div>
            </div>
            <div class="item_info_25">
                <div class="item_icon">
                    <v-icon icon="mdi-file-import"></v-icon>
                </div>
                <div class="item_data">
                    <div class="data_title">{{ ui.managements.pago.importe_pago_ultimo }}</div>
                    <div class="data_info">{{ dataManagementInformation.paymentInformation.importe_pago_ultimo }}</div>
                </div>
            </div>
        </div>

        <header>
            <v-card-title>Registro de Gestión</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <form class="px-4">
            <div class="override_content_flex mt-4">
                <div class="col-flex-4">
                    <v-select
                        label="Contacto con"
                        variant="outlined"
                        class="w-100"
                        data-cy="management-contact"
                        v-model="formGroup.data.titular_aval"
                        :rules="formGroup.rules.titular_aval"
                        :items="arrContactWith"
                        item-title="title"
                        item-value="value"
                    ></v-select>
                </div>

                <div class="col-flex-4">
                    <v-select
                        label="Colaboración con"
                        variant="outlined"
                        class="w-100"
                        v-model="formGroup.data.colaborador"
                        :items="arrColaboradores"
                        item-title="fullName"
                        item-value="username"
                    ></v-select>
                </div>
                <div class="col-flex-4">
                    <v-select
                        :label="catalogSettings.action_label"
                        variant="outlined"
                        data-cy="management-action"
                        v-model="formGroup.data.codigo_accion"
                        :rules="formGroup.rules.codigo_accion"
                        :items="arrActionCodes"
                        item-title="fullName"
                        item-value="id_codigo_accion"
                        class="w-100"
                        @update:model-value="getResultsCodes()"
                    ></v-select>
                </div>
                <div class="col-flex-4">
                    <v-select
                        :label="catalogSettings.result_label"
                        variant="outlined"
                        data-cy="management-result"
                        v-model="formGroup.data.codigo_resultado"
                        :rules="formGroup.rules.codigo_resultado"
                        :items="arrResultsCodes"
                        item-title="fullName"
                        item-value="id_codigo_resultado"
                        class="w-100"
                        :disabled="!formGroup.data.codigo_accion || isLoadingCodeResult || catalogConfigError || arrResultsCodes.length === 0"
                        :hint="formGroup.data.codigo_accion && !isLoadingCodeResult && !arrResultsCodes.length ? 'No hay resultados disponibles para este medio. Revisa las relaciones o la configuración del catálogo.' : ''"
                        persistent-hint
                        :loading="isLoadingCodeResult"
                    ></v-select>
                </div>
                <div v-if="catalogSettings.dictamen_mode !== 'disabled'" class="col-flex-4">
                    <v-select v-if="catalogSettings.dictamen_mode === 'independent'"
                        v-model="formGroup.data.id_dictamen" :label="catalogSettings.dictamen_label"
                        :items="dictamenes" item-title="descripcion" item-value="id_dictamen"
                        variant="outlined" :rules="[v => !!v || 'Seleccione un dictamen.']" />
                    <v-textarea v-else :model-value="derivedDictamen?.descripcion || ''" data-cy="management-derived-dictamen"
                        :label="catalogSettings.dictamen_label" readonly rows="2" auto-grow variant="outlined"
                        :error-messages="formGroup.data.codigo_resultado && !derivedDictamen ? 'El resultado no tiene un dictamen activo configurado.' : ''" />
                </div>
                <div class="col-flex-4">
                    <v-text-field 
                        label="Próximo Contacto" 
                        variant="outlined" 
                        class="w-100"
                        data-cy="management-date"
                        v-model="formGroup.data.fecha_gestion"
                        :rules="formGroup.rules.fecha_gestion"
                        :min="minDate"
                        type="date"
                    ></v-text-field>
                </div>

                <div class="col-flex-4">
                    <v-text-field 
                        label="Horario Próximo Contacto" 
                        variant="outlined" 
                        data-cy="management-time"
                        v-model="formGroup.data.hora_gestion"
                        :rules="formGroup.rules.hora_gestion"
                        class="w-100"
                        type="time"
                        min="08:00" 
                        max="21:00"
                    ></v-text-field>
                </div>
                <div class="col-flex-12">
                    <v-textarea
                        label="Observaciones"
                        variant="outlined"
                        rows="2"
                        data-cy="management-notes"
                        v-model="formGroup.data.observaciones"
                        :rules="formGroup.rules.observaciones"
                        maxLength="160"
                        class="w-100"
                        :hint="formGroup.data.observaciones !== null ? formGroup.data.observaciones.length+'/160' : ''"
                        @keydown.enter.prevent
                    ></v-textarea>
                   <v-snackbar v-model="showSnackbar" timeout="2000" color="warning">
                        No se permite pegar texto aquí.
                    </v-snackbar>
                </div>
                <div class="col-flex-12">
                    <v-switch
                        label="¿Se llegó a convenio?"
                        color="indigo-darken-3"
                        single-line
                        hide-details
                        v-model="formGroup.data.convenio_realizado"
                        :rules="formGroup.rules.convenio_realizado"
                        :disabled="infoClient.estado === 'Convenio Activo' || infoClient.estado === 'Convenio Completado'"
                    ></v-switch>
                    <div v-if="
                        infoClient.estado === 'Convenio Activo' || 
                        infoClient.estado === 'Convenio Completado'
                    ">
                      <i>Convenio activo ligado a la cuenta. No es posible hacer otro convenio en este momento.</i>
                    </div>
                </div>

                <div class="col-flex-4" v-if="formGroup.data.convenio_realizado">
                    <v-text-field
                        label="Saldo del Plan"
                        variant="outlined"
                        type="number"
                        onkeydown="return event.key !== 'e'"
                        v-model="formGroup.data.saldo_plan"
                        :rules="formGroup.rules.saldo_plan"
                        class="w-100"
                        @wheel.prevent
                        @keydown="blockKeys"
                    ></v-text-field>
                </div>
                <div class="col-flex-4" v-if="formGroup.data.convenio_realizado">
                    <v-select
                        label="Opciones de Pago"
                        variant="outlined"
                        :items="arrOptionPayment"
                        item-title="value"
                        item-value="key"
                        v-model="formGroup.data.opcionesPago"
                        :rules="formGroup.rules.opcionesPago"
                        class="w-100"
                        @update:modelValue="llenarSelectPlazos"
                    ></v-select>
                </div>
                <div class="col-flex-4" v-if="formGroup.data.convenio_realizado">
                    <v-select 
                        label="Plazos de pagos"
                        variant="outlined"
                        :items="arrOptionPay"
                        item-title="value"
                        item-value="key"
                        v-model="formGroup.data.opciones_pago"
                        :rules="formGroup.rules.opciones_pago"
                        class="w-100"
                        :disabled="isDisabledSelectPlazos"
                    ></v-select>
                </div>
                <div class="col-flex-4" v-if="formGroup.data.convenio_realizado">
                    <v-text-field
                        label="Pago Inicial"
                        type="number"
                        onkeydown="return event.key !== 'e'"
                        variant="outlined"
                        v-model="formGroup.data.pago_inicial"
                        :rules="formGroup.rules.pago_inicial"
                        class="w-100"
                        @wheel.prevent
                        @keydown="blockKeys"
                    ></v-text-field>
                </div>
                <div class="col-flex-4" v-if="formGroup.data.convenio_realizado">                    
                    <v-text-field 
                        label="Fecha Pago Inicial"
                        variant="outlined" 
                        class="w-100"
                        v-model="formGroup.data.fecha_convenio"
                        :rules="[...formGroup.rules.fecha_convenio, validateFechaQuincenal]"
                        :min="minDate"
                        :error-messages="fechaError"
                        type="date"
                        @change="onFechaChange"
                        @keydown.prevent="blockArrows ? (['ArrowUp','ArrowDown'].includes($event.key)) : false"
                    />
                    
                </div>
                <div class="col-flex-4" v-if="formGroup.data.convenio_realizado">
                    <!-- :rules="formGroup.rules.colaborador_convenio" -->
                    <v-select
                        label="Colaboración con"
                        variant="outlined"
                        class="w-100"
                        v-model="formGroup.data.colaborador_convenio"
                        :items="arrColaboradores"
                        item-title="fullName"
                        item-value="username"
                    ></v-select>
                </div>
                <div class="col-flex-12 mb-5" style="display: flex; flex-direction: row-reverse;">
                    <v-btn
                        variant="flat"
                        color="indigo-darken-3"
                        class="text-none"
                        :disabled="validateForm()" 
                        data-cy="management-review"
                        @click="confirmateForm()"
                        prepend-icon="mdi-content-save-all"
                        text="Guardar"
                    ></v-btn>
                </div>
            </div>
        </form>
    </div>

    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>

    <div v-if="isLoading" class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando la Información del Crédito</div>
    </div>

    <template>
        <v-dialog v-model="dialogSelectedDate.open" width="400px" persistent>
            <v-card>
                <v-card-title>Seleccione una Fecha</v-card-title>
                <v-card-text>
                    <v-date-picker
                        v-model="dialogSelectedDate.data" 
                        :min="minDate"
                        @update:model-value="setDate"
                        :hide-header="true"
                    ></v-date-picker>
                </v-card-text>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <v-dialog v-model="dialogSelectedTime.open" width="230px" persistent>
            <v-card>
                <v-card-title>Seleccione una Hora</v-card-title>
                <v-card-text>
                    <div class="container_time mb-8">
                        <div class="item_time">
                            <div class="time_button mb-5">
                                <v-btn icon="mdi-menu-up" variant="text" @click="changeTime('HOUR', '+')"></v-btn>
                            </div>
                            <div class="display_flex">
                                <div class="item_data_time">
                                    <v-text-field
                                        readonly
                                        variant="outlined"
                                        v-model="dialogSelectedTime.data.hour"
                                    ></v-text-field>
                                </div>
                                <div class="separate_time">:</div>
                            </div>
                            <div class="time_button">
                                <v-btn icon="mdi-menu-down" variant="text" @click="changeTime('HOUR', '-')"></v-btn>
                            </div>
                        </div>
                        <div class="item_time">
                            <div class="time_button mb-5">
                                <v-btn icon="mdi-menu-up" variant="text" @click="changeTime('MINUTE', '+')"></v-btn>
                            </div>
                            <div class="display_flex">
                                <div class="item_data_time">
                                    <v-text-field
                                        readonly
                                        variant="outlined"
                                        v-model="dialogSelectedTime.data.minute"
                                    ></v-text-field>
                                </div>
                                <div class="separate_time">:</div>
                            </div>
                            <div class="time_button">
                                <v-btn icon="mdi-menu-down" variant="text" @click="changeTime('MINUTE', '-')"></v-btn>
                            </div>
                        </div>
                        <div class="item_time">
                            <div class="time_button mb-5">
                                <v-btn icon="mdi-menu-up" variant="text" @click="changeTime('TYPE', '+')"></v-btn>
                            </div>
                            <div class="display_flex">
                                <div class="item_data_time">
                                    <v-text-field
                                        readonly
                                        variant="outlined"
                                        v-model="dialogSelectedTime.data.type"
                                    ></v-text-field>
                                </div>
                            </div>
                            <div class="time_button">
                                <v-btn icon="mdi-menu-down" variant="text" @click="changeTime('TYPE', '-')"></v-btn>
                            </div>
                        </div>
                        
                    </div>
                </v-card-text>
                <v-card-actions style="display: flex; justify-content: center;">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="closeTime()"
                        text="Cancelar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        @click="setTime()"
                        text="Aceptar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <v-dialog v-model="dialogAceptPhones.open" width="600px" persistent>
            <v-card>
                <v-card-title>Confirmar Número de Contacto</v-card-title>
                <v-card-text>
                    <form class="override_content_flex">
                        <div class="col-flex-12">
                            <v-text-field
                                label="Número de Teléfono"
                                type="number"
                                variant="outlined"
                                v-model="dialogAceptPhones.phone"
                                :rules="dialogAceptPhones.validate"
                                maxlength="10"
                                v-on:input="limitarTel()"
                                class="w-100"
                                onkeydown="return event.key !== 'e'"
                                @wheel.prevent
                                @keydown="blockKeys"
                            ></v-text-field>
                        </div>
                    </form>

                    <div style="display: flex;">
                        <div style="width: calc(100% - 115px); font-weight: 600; display: flex;">
                            <div style="height: 40px;
                                width: 40px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #D9D92C;
                                margin: 5px;">
                                <v-icon>mdi-alert</v-icon>
                            </div>
                            <div>
                                Debe seleccionar un número de teléfono para continuar 
                            </div>
                        </div>
                        <div>
                            <v-btn
                                class="text-none elevation-0"
                                color="indigo-darken-3"
                                prepend-icon="mdi-content-save-all"
                                :loading="dialogAceptPhones.loading"
                                :disabled="validateFormPhone()"
                                @click="createTelephoneByClient()"
                                text="Guardar"
                            ></v-btn>
                        </div>
                    </div>

                    <v-data-table
                        data-cy="management-phone-table"
                        :headers="dataSourcePhone.headers"
                        :items="dataSourcePhone.data"
                        :loading="dialogAceptPhones.loading"
                        no-data-text="Sin datos para mostrar"
                        loading-text="Cargando información... Espere un momento"
                    >
                        <template v-slot:loading>
                            <v-skeleton-loader type="table-row@3" aria-label="Cargando teléfonos" />
                        </template>
                        <template v-slot:[`item.reaction`]="{ item }">
                            <v-btn-toggle :color="item.reaction === 0 ? 'teal-darken-3' : 'red-darken-4'" v-model="item.reaction">
                                <v-btn @click="changeReaction(item)">
                                    <v-icon>mdi-check</v-icon>
                                </v-btn>
                                <v-btn @click="changeReaction(item)">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions class="actions_buttons">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="cancelConfirmate()"
                        text="Cancelar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        @click="confirmateFormPhones()"
                        :disabled="!valdiateForm()"
                        text="Aceptar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
      <v-dialog v-model="dialogConfirmate.open" width="500px" persistent>
          <v-card>
              <v-card-title>
                  <span class="text-h5">Confirmación</span>
              </v-card-title>
              <v-card-text>
                <div v-if="!dialogConfirmate.loading">
                  <div class="text-center">
                      <img class="img-graphics" src="@/assets/images/warning.png">
                  </div>
                  <div class="description-text">
                      <p>¿Está seguro de registrar la gestión?</p>
                  </div>
                </div>
                <div class="content_load" v-if="dialogConfirmate.loading">
                  <v-progress-circular
                    :size="100"
                    :width="7"
                    color="indigo-darken-3"
                    indeterminate
                  ></v-progress-circular>
                  <i>Espere un momento</i>
                  <div>Registrando la información</div>
                </div>
              </v-card-text>
              <v-card-actions class="actions_buttons" v-if="!dialogConfirmate.loading">
                  <v-btn 
                    variant="flat"
                    class="text-none"
                    color="red"
                    @click="cancelConfirmate()"
                    text="Cancelar"
                ></v-btn>
                  <v-btn 
                    variant="flat"
                    class="text-none"
                    color="indigo-darken-3"
                    @click="saveGestion()" 
                    :loading="dialogConfirmate.loading"
                    text="Aceptar"
                ></v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </template>

    <SnackbarComponent :value="snackbarData"/>
</template>

<script>
import { useManagementCatalogStore } from '@/stores/managementCatalog';
import ClientSummary from '@/components/managements/ClientSummary.vue'
import SnackbarComponent from '@/components/Snackbar'
import { EncryptService } from '@/services/EncryptService';
import { ManagementsService } from '@/services/ManagementsService';
import { ResourcesService } from '@/services/ResourcesService';
import { useUiStore } from '@/stores/ui'
export default {
    name: "FormManagementView",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },    
    data() {
        return {
            idClient: null,
            telephoneManagement: '',
            isLoading: false,
            showSnackbar: false,
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            dataManagementInformation: {
                generalInformation: {
                    id_cliente: null,
                    nombre: null,
                    edad: null,
                    cartera: null,
                    producto: null,
                    correo_electronico: null,
                    estatus_plan: null,
                    rmd: null,
                    rfc: null,
                    territorio: null,
                    zona: null,
                    gerencia: null,
                } | null,
                paymentInformation: {
                    total: null,
                    dia_de_pago: null,
                    atraso_max: null,
                    moratorios: null,
                    fecha_pago_ultimo: null,
                    id_grupo: null,
                    saldo: null,
                    importe_pago_ultimo: null,
                    nombre_grupo: null,
                    campania: null,
                    fecha_asignacion: null,
                    dias_asignacion: null,
                } | null,
                directionInformation: {
                    direccion: null,
                    num_ext: null,
                    num_int: null,
                    colonia: null,
                    poblacion: null,
                    estado: null,
                    cp: null,
                    cuadrante: null,
                    referencia_domicilio: null,
                } | null,
                trabajoInformation: {
                    direccion: null,
                    num_ext: null,
                    num_int: null,
                    colonia: null,
                    poblacion: null,
                    estado: null,
                } | null,
                avalInformation: {
                    nombre_aval: null,
                    direccion: null,
                    num_ext: null,
                    num_int: null,
                    colonia: null,
                    poblacion: null,
                    estado: null,
                    cp: null,
                    numero_tel: null,
                } | null,
            },

            dialogSelectedDate: {
                option: '',
                open: false,
                data: new Date(),
            },
            dialogSelectedTime: {
                option: '',
                open: false,
                data: {
                    hour: '08',
                    minute: '00',
                    type: 'AM',
                },
            },
            catalogConfigError: true, resultRequestVersion: 0,
            formGroup: {
                data: {
                    titular_aval: 1,
                    colaborador: null,
                    codigo_accion: null,
                    codigo_resultado: null,
                    id_dictamen: null,
                    fecha_gestion: null,
                    hora_gestion: null,
                    observaciones: null,
                    convenio_realizado: false,
                    saldo_plan: null,
                    opciones_pago: null,
                    pago_inicial: null,
                    fecha_convenio: null,
                    colaborador_convenio: null,
                    opcionesPago:'SEMANAL',
                },
                rules: {
                    titular_aval: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Contacto con es obligatorio`
                            }
                            return true
                        }
                    ],
                    colaborador: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Colaboración con es obligatorio`
                            }
                            return true
                        }
                    ],
                    codigo_accion: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo ${this.catalogSettings.action_label} es obligatorio`
                            }
                            return true
                        }
                    ],
                    codigo_resultado: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo ${this.catalogSettings.result_label} es obligatorio`
                            }
                            return true
                        }
                    ],
                    fecha_gestion: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Horario Próximo Contacto es obligatorio`
                            }
                            return true
                        }
                    ],
                    hora_gestion: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Próximo Contacto es obligatorio`
                            }

                            if (!value) return "Debe ingresar una hora";

                            const [HOUR, MINUTE] = value.split(":").map(Number);

                            if (HOUR === 21 && MINUTE > 0) return "El horario no es válido";

                            if (HOUR < 8 || HOUR > 21) return "El horario no es válido";

                            return true;
                        }
                    ],
                    observaciones: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Observaciones es obligatorio`
                            }
                            if (!/^[a-zA-Z0-9./\s]*$/.test(value)) {
                                return 'Solo se permiten letras, números, puntos (.) y barras (/)';
                            }
                            return true
                        }
                    ],
                    convenio_realizado: [
                        () => {
                            if (
                                this.infoClient.estado === 'Convenio Activo' || 
                                this.infoClient.estado === 'Convenio Completado'
                            ) {
                                return `Convenio activo ligado a la cuenta. No es posible hacer otro convenio en este momento.`
                            }
                            return true
                        }
                    ],
                    saldo_plan: [
                        value => {
                            if (value === '' || value === undefined || value === null) {
                                return 'El campo Saldo del Plan es obligatorio'
                            } else if (parseFloat(value) <= 0) {
                                return 'El campo Saldo del Plan debe ser mayor a 0'
                            } else if (parseFloat(value) > parseFloat(this.infoClient.total)) {
                                return `El campo Saldo del Plan no debe ser mayor a ${this.infoClient.totalUpdate}`
                            }
                            return true
                        }
                    ],
                    opciones_pago: [
                        value => {
                            if (value === null || value === undefined || value === '' && this.formGroup.data.opcionesPago !== 'LIQUIDACION') {
                                return `El campo Opciones de Pago es obligatorio`
                            }
                            return true
                        }
                    ],
                    pago_inicial: [
                        value => {
                            if (this.formGroup.data.convenio_realizado === true) {
                                if (value === null || value === undefined || value === '') {
                                    return 'El campo Pago Inicial es obligatorio'
                                }
                                if (parseFloat(value) > parseFloat(this.formGroup.data.saldo_plan)) {
                                    return 'El campo Pago Inicial no debe ser mayor al Saldo Plan'
                                }
                                if (this.formGroup.data.opciones_pago === 0 && parseFloat(value) !== parseFloat(this.formGroup.data.saldo_plan)) {
                                    return 'El campo Pago Inicial debe ser igual al campo Saldo Plan'
                                }
                                if (this.formGroup.data.opciones_pago !== 0 && parseFloat(value) > parseFloat(this.formGroup.data.saldo_plan)) {
                                    return 'El campo Pago Inicial debe ser menor al campo Saldo Plan'
                                }
                            }
                            if (this.formGroup.data.convenio_realizado === true && value === '') {
                                return 'El campo Pago Inicial es obligatorio'
                            } else if (parseFloat(value) <= 0) {
                                return 'El campo Pago Inicial debe ser mayor a 0'
                            } else if (this.formGroup.data.convenio_realizado === true && parseFloat(value) > parseFloat(this.formGroup.data.saldo_plan)) {
                                return 'El campo Pago Inicial no debe ser mayor al Saldo Plan'
                            }
                            return true
                        }
                    ],
                    fecha_convenio: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Fecha Pago Inicial es obligatorio`
                            }
                            return true
                        }
                    ],
                    colaborador_convenio: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Colaboración con es obligatorio`
                            }
                            return true
                        }
                    ],
                    opcionesPago : [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Opciones de Pago es obligatorio`
                            }
                            return true
                        }
                    ]
                }
            },
            arrContactWith: [
                { title: "Títular", value: 1 },
                { title: "Aval", value: 2 },
                { title: "Tercero", value: 3 },
            ],
            arrColaboradores: [],
            arrActionCodes: [],
            arrResultsCodes: [],
            arrOptionPay: [],
            arrOptionPayment:[
                {key:'LIQUIDACION',value:'Un solo pago (Liquidación)'},                
                {key:'SEMANAL',value:'Semanal'},
                {key:'QUINCENAL',value:'Quincenal'},
                {key:'MENSUAL',value:'Mensual'},                                
            ],            
            minDate: new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString().substr(0, 10),

            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            dialogAceptPhones: {
                open: false,
                loading: false,
                phone: null,
                validate: [
                    value => {
                        if (value === null || value === undefined || value === '') {
                            return `El campo es obligatorio`
                        }
                        const PHONE = value.toString();
                        if (PHONE.length !== 10) {
                            return `El campo debe contener 10 dígitos`
                        }
                        return true
                    }
                ]
            },
            dialogConfirmate: {
                open: false,
                loading: false,
            },
            dataSourcePhone: {
                headers: [
                    {
                        align: "start",
                        sortable: false,
                        key: "reaction",
                        title: "Aceptar / Rechazar",
                    },
                    {
                        key: "numero_tel",
                        title: "Números de Teléfono",
                    },
                ],
                data: [],
            },
            isLoadingCodeResult: false,
            typeClassConvenio: 'gray',
            isDisabledSelectPlazos:true,             
            fechaError: '',
            blockArrows: true,
        }
    },
    watch: {
        'formGroup.data.codigo_resultado'() { this.syncLinkedDictamen(); },
        'catalogSettings.dictamen_mode'() { this.formGroup.data.id_dictamen = null; this.syncLinkedDictamen(); },
    },
    computed:{
        catalogSettings() { return useManagementCatalogStore().settings; },
        dictamenes() { return useManagementCatalogStore().dictamenes; },
        derivedDictamen() {
            if (!this.formGroup.data.codigo_resultado) return null;
            return this.dictamenes.find(d => Number(d.id_codigo_resultado) === Number(this.formGroup.data.codigo_resultado));
        },
        ui() {
            const store = useUiStore()
            return store.ui?.managements?.pago ? store.ui : { managements: { pago: { saldo: 'Saldo', atraso_max: 'Atraso máximo', fecha_pago_ultimo: 'Fecha del último pago', importe_pago_ultimo: 'Importe del último pago' } } };
        },
    },
    async mounted() {
        try {
            await useManagementCatalogStore().load();
            this.syncLinkedDictamen();
            this.catalogConfigError = false;
            if (this.catalogSettings.auto_select_single && this.arrResultsCodes.length === 1) this.formGroup.data.codigo_resultado = this.arrResultsCodes[0].id_codigo_resultado;
        } catch (e) {
            this.catalogConfigError = true;
            this.snackbarData = { openSnackbar: true, description: 'No se pudo cargar la configuración de gestión. Recargue antes de guardar.' };
        }
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created () {
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id

        this.$watch(
            () => this.formGroup.data.opcionesPago,   // ⚠️ usa función en Vue 3
            () => { this.validarActual(true); },
            { immediate: false }
        );

        if(this.formGroup.data.opcionesPago === 'SEMANAL'){
            this.llenarSelectPlazos();
        }

        this.isLoading = true
        await this.getAllManagementInformation()
        await this.getColaborators()
        await this.getActionCodes()
        await this.getClientInformation()
        await this.getTelephonesByClient()
        this.isLoading = false
    },
    methods: {
        syncLinkedDictamen() {
            if (this.catalogSettings.auto_select_dictamen) {
                this.formGroup.data.id_dictamen = this.derivedDictamen?.id_dictamen || null;
            }
        },
        onPaste() {
            this.showSnackbar = true

            setTimeout(() => {
                this.showSnackbar = false
            }, 2000)
        },
        blockKeys(event) {
            if (["ArrowUp", "ArrowDown", "e"].includes(event.key)) {
                event.preventDefault();
            }
        },
        getAllManagementInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getAllManagementInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {

                        const GENERAL_INFORMATION = responseData.response.generalInformation
                        if (GENERAL_INFORMATION !== null) {
                            responseData.response.generalInformation.id_cliente = GENERAL_INFORMATION.id_cliente === null ? 'N/A' : GENERAL_INFORMATION.id_cliente
                            responseData.response.generalInformation.nombre = GENERAL_INFORMATION.nombre === null ? 'N/A' : GENERAL_INFORMATION.nombre
                            responseData.response.generalInformation.nombre = GENERAL_INFORMATION.nombre === null ? 'N/A' : GENERAL_INFORMATION.nombre
                            responseData.response.generalInformation.edad = GENERAL_INFORMATION.edad === null ? 'N/A' : GENERAL_INFORMATION.edad
                            responseData.response.generalInformation.cartera = GENERAL_INFORMATION.cartera === null ? 'N/A' : GENERAL_INFORMATION.cartera
                            responseData.response.generalInformation.producto = GENERAL_INFORMATION.producto === null ? 'N/A' : GENERAL_INFORMATION.producto
                            responseData.response.generalInformation.correo_electronico = GENERAL_INFORMATION.correo_electronico === null ? 'N/A' : GENERAL_INFORMATION.correo_electronico
                            responseData.response.generalInformation.estatus_plan = GENERAL_INFORMATION.estatus_plan === null ? 'N/A' : GENERAL_INFORMATION.estatus_plan
                            responseData.response.generalInformation.estatus_plan = GENERAL_INFORMATION.estatus_plan === null ? 'N/A' : GENERAL_INFORMATION.estatus_plan
                            responseData.response.generalInformation.rfc = GENERAL_INFORMATION.rfc === null ? 'N/A' : GENERAL_INFORMATION.rfc
                            responseData.response.generalInformation.territorio = GENERAL_INFORMATION.territorio === null ? 'N/A' : GENERAL_INFORMATION.territorio
                            responseData.response.generalInformation.zona = GENERAL_INFORMATION.zona === null ? 'N/A' : GENERAL_INFORMATION.zona
                            responseData.response.generalInformation.gerencia = GENERAL_INFORMATION.gerencia === null ? 'N/A' : GENERAL_INFORMATION.gerencia
                        }

                        const PAYMENT_INFORMATION = responseData.response.paymentInformation
                        if (PAYMENT_INFORMATION !== null) {
                            responseData.response.paymentInformation.total = PAYMENT_INFORMATION.total === null ? 'N/A' : ResourcesService.moneyFormat(PAYMENT_INFORMATION.total)
                            responseData.response.paymentInformation.dia_de_pago = PAYMENT_INFORMATION.dia_de_pago === null ? 'N/A' : PAYMENT_INFORMATION.dia_de_pago
                            responseData.response.paymentInformation.atraso_max = PAYMENT_INFORMATION.atraso_max === null ? 'N/A' : PAYMENT_INFORMATION.atraso_max
                            responseData.response.paymentInformation.moratorios = PAYMENT_INFORMATION.moratorios === null ? 'N/A' : ResourcesService.moneyFormat(PAYMENT_INFORMATION.moratorios)
                            responseData.response.paymentInformation.fecha_pago_ultimo = PAYMENT_INFORMATION.fecha_pago_ultimo === null ? 'N/A' : PAYMENT_INFORMATION.fecha_pago_ultimo
                            responseData.response.paymentInformation.id_grupo = PAYMENT_INFORMATION.id_grupo === null ? 'N/A' : PAYMENT_INFORMATION.id_grupo
                            responseData.response.paymentInformation.saldo = PAYMENT_INFORMATION.saldo === null ? 'N/A' : ResourcesService.moneyFormat(PAYMENT_INFORMATION.saldo)
                            responseData.response.paymentInformation.importe_pago_ultimo = PAYMENT_INFORMATION.importe_pago_ultimo === null ? 'N/A' : ResourcesService.moneyFormat(PAYMENT_INFORMATION.importe_pago_ultimo)
                            responseData.response.paymentInformation.nombre_grupo = PAYMENT_INFORMATION.nombre_grupo === null ? 'N/A' : PAYMENT_INFORMATION.nombre_grupo
                            responseData.response.paymentInformation.campania = PAYMENT_INFORMATION.campania === null ? 'N/A' : PAYMENT_INFORMATION.campania
                            responseData.response.paymentInformation.fecha_asignacion = PAYMENT_INFORMATION.fecha_asignacion === null ? 'N/A' : PAYMENT_INFORMATION.fecha_asignacion
                            responseData.response.paymentInformation.dias_asignacion = PAYMENT_INFORMATION.dias_asignacion === null ? 'N/A' : PAYMENT_INFORMATION.dias_asignacion
                        }
                        
                        const DIRECTION_INFORMATION = responseData.response.directionInformation
                        if (DIRECTION_INFORMATION !== null) {
                            responseData.response.directionInformation.direccion = DIRECTION_INFORMATION.direccion === null ? 'N/A' : DIRECTION_INFORMATION.direccion
                            responseData.response.directionInformation.num_ext = DIRECTION_INFORMATION.num_ext === null ? 'N/A' : DIRECTION_INFORMATION.num_ext
                            responseData.response.directionInformation.num_int = DIRECTION_INFORMATION.num_int === null ? 'N/A' : DIRECTION_INFORMATION.num_int
                            responseData.response.directionInformation.colonia = DIRECTION_INFORMATION.colonia === null ? 'N/A' : DIRECTION_INFORMATION.colonia
                            responseData.response.directionInformation.poblacion = DIRECTION_INFORMATION.poblacion === null ? 'N/A' : DIRECTION_INFORMATION.poblacion
                            responseData.response.directionInformation.estado = DIRECTION_INFORMATION.estado === null ? 'N/A' : DIRECTION_INFORMATION.estado
                            responseData.response.directionInformation.cp = DIRECTION_INFORMATION.cp === null ? 'N/A' : DIRECTION_INFORMATION.cp
                            responseData.response.directionInformation.cuadrante = DIRECTION_INFORMATION.cuadrante === null ? 'N/A' : DIRECTION_INFORMATION.cuadrante
                            responseData.response.directionInformation.referencia_domicilio = DIRECTION_INFORMATION.referencia_domicilio === null ? 'N/A' : DIRECTION_INFORMATION.referencia_domicilio
                        }

                        const WORK_INFORMATION = responseData.response.trabajoInformation
                        if (WORK_INFORMATION !== null) {
                            responseData.response.trabajoInformation.direccion = WORK_INFORMATION.direccion === null ? 'N/A' : WORK_INFORMATION.direccion
                            responseData.response.trabajoInformation.num_ext = WORK_INFORMATION.num_ext === null ? 'N/A' : WORK_INFORMATION.num_ext
                            responseData.response.trabajoInformation.num_int = WORK_INFORMATION.num_int === null ? 'N/A' : WORK_INFORMATION.num_int
                            responseData.response.trabajoInformation.colonia = WORK_INFORMATION.colonia === null ? 'N/A' : WORK_INFORMATION.colonia
                            responseData.response.trabajoInformation.poblacion = WORK_INFORMATION.poblacion === null ? 'N/A' : WORK_INFORMATION.poblacion
                            responseData.response.trabajoInformation.estado = WORK_INFORMATION.estado === null ? 'N/A' : WORK_INFORMATION.estado
                        }

                        const AVAL_INFORMATION = responseData.response.avalInformation
                        if (AVAL_INFORMATION !== null) {
                            responseData.response.avalInformation.nombre_aval = AVAL_INFORMATION.nombre_aval === null ? 'N/A' : AVAL_INFORMATION.nombre_aval
                            responseData.response.avalInformation.direccion = AVAL_INFORMATION.direccion === null ? 'N/A' : AVAL_INFORMATION.direccion
                            responseData.response.avalInformation.num_ext = AVAL_INFORMATION.num_ext === null ? 'N/A' : AVAL_INFORMATION.num_ext
                            responseData.response.avalInformation.num_int = AVAL_INFORMATION.num_int === null ? 'N/A' : AVAL_INFORMATION.num_int
                            responseData.response.avalInformation.colonia = AVAL_INFORMATION.colonia === null ? 'N/A' : AVAL_INFORMATION.colonia
                            responseData.response.avalInformation.poblacion = AVAL_INFORMATION.poblacion === null ? 'N/A' : AVAL_INFORMATION.poblacion
                            responseData.response.avalInformation.estado = AVAL_INFORMATION.estado === null ? 'N/A' : AVAL_INFORMATION.estado
                            responseData.response.avalInformation.cp = AVAL_INFORMATION.cp === null ? 'N/A' : AVAL_INFORMATION.cp
                            responseData.response.avalInformation.numero_tel = AVAL_INFORMATION.numero_tel === null ? 'N/A' : AVAL_INFORMATION.numero_tel
                        } 

                        this.dataManagementInformation = responseData.response

                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getColaborators: async function () {
            await ManagementsService.getColaborators().then(
                (responseData) => {
                    if (!responseData.error) {
                        this.arrColaboradores = [{ username: null, fullName: `--Sin colaboración--` }]
                        for (let index = 0; index < responseData.response.length; index++) {
                            let element = responseData.response[index]
                            element.fullName = `${element.name} ${element.last_name} (${element.username})`
                            responseData.response[index] = element
                        }
                        this.arrColaboradores = this.arrColaboradores.concat(responseData.response)
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getActionCodes: async function () {
            await ManagementsService.getActionCodes().then(
                (responseData) => {
                    if (!responseData.error) {
                        for (let index = 0; index < responseData.response.length; index++) {
                            let element = responseData.response[index]
                            element.fullName = element.descripcion ? `${element.descripcion} (${element.codigo})` : element.codigo
                            responseData.response[index] = element
                        }
                        this.arrActionCodes = responseData.response
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getResultsCodes: async function () {
            const version = ++this.resultRequestVersion;
            this.formGroup.data.codigo_resultado = null;
            this.arrResultsCodes = [];
            const action = this.formGroup.data.codigo_accion;
            if (!action) { this.isLoadingCodeResult = false; return; }
            this.isLoadingCodeResult = true;
            try {
                const encrypted = await EncryptService.encrypt(String(action));
                const response = await ManagementsService.getResultsCodes(encrypted);
                if (version !== this.resultRequestVersion) return;
                if (response.error || !Array.isArray(response.response)) throw new Error(response.msg || response.message || 'No se pudieron cargar los resultados.');
                this.arrResultsCodes = response.response.map(item => ({ ...item, fullName: item.descripcion ? `${item.descripcion} (${item.codigo})` : item.codigo }));
                if (this.catalogSettings.auto_select_single && this.arrResultsCodes.length === 1) {
                    this.formGroup.data.codigo_resultado = this.arrResultsCodes[0].id_codigo_resultado;
                }
            } catch (e) {
                if (version === this.resultRequestVersion) this.snackbarData = { openSnackbar: true, description: e.message };
            } finally {
                if (version === this.resultRequestVersion) this.isLoadingCodeResult = false;
            }
        },
        selectedDate: function (TYPE_OPTION) {
            this.dialogSelectedDate.option = TYPE_OPTION
            this.dialogSelectedDate.open = true
        },
        selectedTime: function (TYPE_OPTION) {
            this.dialogSelectedTime.option = TYPE_OPTION
            this.dialogSelectedTime.open = true
        },
        setDate: function () {
            if (!this.dialogSelectedDate.data) return; // Validar que hay una fecha

            const OPTION = this.dialogSelectedDate.option;
            let dateObj = new Date(this.dialogSelectedDate.data);

            if (isNaN(dateObj)) return; // Validar que la fecha sea válida

            let year = dateObj.getFullYear();
            let month = dateObj.getMonth();
            let day = dateObj.getDate();

            // Obtener el último día del mes seleccionado
            let lastDayOfMonth = new Date(year, month + 1, 0).getDate();

            // Si el día es mayor que el último día del mes, ajustarlo
            if (day > lastDayOfMonth) {
                day = lastDayOfMonth;
            }

            // Formatear la fecha en DD-MM-YYYY
            const DATE_SELECTED = `${('0' + day).slice(-2)}-${('0' + (month + 1)).slice(-2)}-${year}`;

            switch (OPTION) {
                case 'DATE_CONTRACT':
                    this.formGroup.data.fecha_gestion = DATE_SELECTED;
                    break;
                case 'DATE_CONVENTION':
                    this.formGroup.data.fecha_convenio = DATE_SELECTED;
                    break;
            }

            this.dialogSelectedDate.open = false;
        },
        changeTime: function (TYPE_TIME, OPTION) {
            if (TYPE_TIME === 'HOUR') {
                let hour = parseInt(this.dialogSelectedTime.data.hour)
                let minute = parseInt(this.dialogSelectedTime.data.minute)
                let type = this.dialogSelectedTime.data.type

                if (OPTION === '+') {
                    if (type === 'AM') {
                        if (hour + 1 === 12) {
                            hour = 12
                            // minute = 0
                            type = 'PM'
                        } else {
                            hour += 1
                        }
                        
                    } else if (type === 'PM') {
                        if (hour + 1 === 10) {
                            hour = 8
                            minute = 0
                            type = 'AM'
                        } else if (hour + 1 === 13) {
                            hour = 1
                            type = 'PM'
                        } else if (hour + 1 === 9) {
                            hour = 9
                            minute = 0
                        }else {
                            hour += 1
                        }
                    }
                } else if (OPTION === '-') {
                    if (type === 'AM') {
                        if (hour - 1 === 7) {
                            hour = 9
                            minute = 0
                            type = 'PM'
                        } else {
                            hour -= 1
                        }
                    } else if (type === 'PM') {
                        if (hour === 1) { 
                            hour = 12
                            type = 'PM'
                        } else if (hour === 12) { 
                            hour = 11
                            type = 'AM'
                        } else {
                            hour -= 1
                        }
                    }
                }
                
                this.dialogSelectedTime.data.hour = hour < 10 ? `0${hour}` : `${hour}`
                this.dialogSelectedTime.data.minute = minute < 10 ? `0${minute}` : `${minute}`  
                this.dialogSelectedTime.data.type = type
                return;
            }
            if (TYPE_TIME === 'MINUTE') {
                let hour = parseInt(this.dialogSelectedTime.data.hour)
                let minute = parseInt(this.dialogSelectedTime.data.minute)
                let type = this.dialogSelectedTime.data.type

                if (OPTION === '+') {
                    if (type === 'AM') {
                        if (minute + 1 === 60) {
                            this.changeTime('HOUR', '+')
                            hour = parseInt(this.dialogSelectedTime.data.hour)
                            type = this.dialogSelectedTime.data.type
                            minute = 0
                        } else {
                            minute += 1
                        }
                    } else if (type === 'PM') {
                        if (minute + 1 === 60 || (hour === 9 && minute >= 0)) {
                            this.changeTime('HOUR', '+')
                            hour = parseInt(this.dialogSelectedTime.data.hour)
                            type = this.dialogSelectedTime.data.type
                            minute = 0
                        } else {
                            minute += 1
                        }
                    }
                } else if (OPTION === '-') {
                    if (type === 'AM') {
                        if ((minute - 1 === -1) || (hour === 9 && minute >= 0)) {
                            this.changeTime('HOUR', '-')
                            hour = parseInt(this.dialogSelectedTime.data.hour)
                            type = this.dialogSelectedTime.data.type
                            if (hour === 9 && type === 'PM') {
                                minute = 0
                            } else {
                                minute = 59
                            }
                        } else {
                            minute -= 1
                        }
                    } else if (type === 'PM') {
                        if ((minute - 1 === -1) || (hour === 9 && minute >= 0)) {
                            this.changeTime('HOUR', '-')
                            hour = parseInt(this.dialogSelectedTime.data.hour)
                            type = this.dialogSelectedTime.data.type
                            minute = 59
                        } else {
                            minute -= 1
                        }
                    }
                }

                this.dialogSelectedTime.data.hour = hour < 10 ? `0${hour}` : `${hour}`
                this.dialogSelectedTime.data.minute = minute < 10 ? `0${minute}` : `${minute}`  
                this.dialogSelectedTime.data.type = type
                return;
            }
            if (TYPE_TIME === 'TYPE') {
                let hour = parseInt(this.dialogSelectedTime.data.hour)
                let type = this.dialogSelectedTime.data.type
                if (type === 'AM') {
                    type = 'PM'
                    if (hour > 9) {
                        hour = 9;
                        this.dialogSelectedTime.data.hour = hour < 10 ? `0${hour}` : `${hour}`
                    }
                } else if (type === 'PM') {
                    type = 'AM'
                    if (hour < 8) {
                        hour = 8;
                        this.dialogSelectedTime.data.hour = hour < 10 ? `0${hour}` : `${hour}`
                    }
                }
                this.dialogSelectedTime.data.type = type
            }
        },
        closeTime: function () {
            this.dialogSelectedTime.data.hour = '08'
            this.dialogSelectedTime.data.minute = '00'
            this.dialogSelectedTime.data.type = 'AM'
            this.dialogSelectedTime.option = ''
            this.dialogSelectedTime.open = false
        },
        setTime: function () {
            let HOUR = this.dialogSelectedTime.data.hour
            let MINUTE = this.dialogSelectedTime.data.minute
            let SECOND = '00'
            let TYPE = this.dialogSelectedTime.data.type

            if (TYPE === 'PM') {
                let hourInt = parseInt(HOUR) + 12;
                if (hourInt === 24) {
                    hourInt = '00'
                }
                HOUR = hourInt
            }

            const TIME_CLOCK = `${HOUR}:${MINUTE}:${SECOND}`
            const OPTION = this.dialogSelectedTime.option

            switch (OPTION) {
                case 'TIME_CONTRACT':
                    this.formGroup.data.hora_gestion = TIME_CLOCK
                    break
                default:
                    this.snackbarData.description = `Opción no disponible`
                    this.snackbarData.openSnackbar = true
            }
            this.dialogSelectedTime.open = false
        },
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.infoClient = responseData.response
                        this.infoClient.totalUpdate = ResourcesService.moneyFormat(parseInt(this.infoClient.total))
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        validateForm: function () {
            let titular_aval = this.formGroup.data.titular_aval
            if (titular_aval === null || titular_aval === '' || titular_aval === undefined) {
                return true
            }
            let codigo_accion = this.formGroup.data.codigo_accion
            if (codigo_accion === null || codigo_accion === '' || codigo_accion === undefined) {
                return true
            }
            let codigo_resultado = this.formGroup.data.codigo_resultado
            if (codigo_resultado === null || codigo_resultado === '' || codigo_resultado === undefined) {
                return true
            }
            let fecha_gestion = this.formGroup.data.fecha_gestion
            if (fecha_gestion === null || fecha_gestion === '' || fecha_gestion === undefined) {
                return true
            }
            let hora_gestion = this.formGroup.data.hora_gestion
            if (hora_gestion === null || hora_gestion === '' || hora_gestion === undefined) {
                return true
            }
            const HOUR = hora_gestion.split(':')[0];
            const MINUTE = hora_gestion.split(':')[1];
            if (
                (HOUR === '21' && parseInt(MINUTE) > 0) || HOUR === '22' || 
                HOUR === '23' || HOUR === '24' || HOUR === '01' || 
                HOUR === '02' || HOUR === '03' || HOUR === '04' || 
                HOUR === '05' || HOUR === '06' || HOUR === '07'
            ) {
                return true
            }
            let observaciones = this.formGroup.data.observaciones
            if (observaciones === null || observaciones === '' || observaciones === undefined) {
                return true
            }

            if (!/^[a-zA-Z0-9./\s]*$/.test(observaciones)) {
                return true;
            }
            
            const CONVENIO_REALIZADO = this.formGroup.data.convenio_realizado

            let saldo_plan = this.formGroup.data.saldo_plan
            if (CONVENIO_REALIZADO === true && (saldo_plan === null || saldo_plan === '' || saldo_plan === undefined || parseInt(saldo_plan) < 0)) {
                return true
            }
            let opciones_pago = this.formGroup.data.opciones_pago
            if (CONVENIO_REALIZADO === true && (opciones_pago === null || opciones_pago === '' || opciones_pago === undefined) && this.formGroup.data.opcionesPago !== 'LIQUIDACION') {
                return true
            }
            let pago_inicial = this.formGroup.data.pago_inicial
            if (CONVENIO_REALIZADO === true && (pago_inicial === null || pago_inicial === '' || pago_inicial === undefined|| parseInt(pago_inicial) < 0)) {
                return true
            }
            let fecha_convenio = this.formGroup.data.fecha_convenio
            if (CONVENIO_REALIZADO === true && (fecha_convenio === null || fecha_convenio === '' || fecha_convenio === undefined)) {
                return true
            }

            let tipos_pagos = this.formGroup.data.opcionesPago
            if (CONVENIO_REALIZADO === true && (tipos_pagos === null || tipos_pagos === '' || tipos_pagos === undefined)) {
                return true
            }

            if (parseFloat(saldo_plan) > parseFloat(this.infoClient.total)) {
                return true
            }

            if (CONVENIO_REALIZADO === true) {
                if (parseFloat(pago_inicial) > parseFloat(saldo_plan)) {
                    return true
                }
                if (this.formGroup.data.opciones_pago === 0 && parseFloat(pago_inicial) !== parseFloat(saldo_plan)) {
                    return true
                }
                if (this.formGroup.data.opciones_pago !== 0 && parseFloat(pago_inicial) > parseFloat(saldo_plan)) {
                    return true
                }
            }
            if (this.formGroup.data.convenio_realizado === true && pago_inicial === '') {
                return true
            } else if (this.formGroup.data.convenio_realizado === true && parseFloat(pago_inicial) > parseFloat(saldo_plan)) {
                return true
            }

            return false
        },
        confirmateForm: function () {
            this.dialogAceptPhones.phone = null
            this.dialogAceptPhones.open = true
        },
        limitarTel: function () {
            this.dialogAceptPhones.phone = this.dialogAceptPhones.phone.replace(/\D/g, '');
            if (this.dialogAceptPhones.phone.length > 10) {
                this.dialogAceptPhones.phone = this.dialogAceptPhones.phone.slice(0, 10);
            }
        },
        clearForm: function () {
            this.formGroup.data.titular_aval = null
            this.formGroup.data.fecha_gestion = null
            this.formGroup.data.hora_gestion = null
            this.formGroup.data.observaciones = null
            this.formGroup.data.colaborador = null
            this.formGroup.data.codigo_accion = null
            this.formGroup.data.codigo_resultado = null
            this.formGroup.data.id_dictamen = null
            this.formGroup.data.convenio_realizado = false
            this.formGroup.data.pago_inicial = null
            this.formGroup.data.fecha_convenio = null
            this.formGroup.data.saldo_plan = null
            this.formGroup.data.opciones_pago = null
            this.formGroup.data.colaborador_convenio = null
            this.dialogAceptPhones.phone = null
        },
        validateFormPhone: function () {
            const PHONE = this.dialogAceptPhones.phone
            if (PHONE === null || PHONE === undefined || PHONE === '') {
                return true
            }
            
            if (PHONE.toString().length !== 10) {
                return true
            }

            return false
        },
        getTelephonesByClient: async function () {
            this.dialogAceptPhones.loading = true
            try {
                const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
                await ManagementsService.getTelephonesByClient(ENC_CLIENT).then(
                    (responseData) => {
                        if (!responseData.error) {
                            for (let index = 0; index < responseData.response.length; index++) {
                                let element = responseData.response[index];
                                element.mismo_numero = element.relacion.length
                                element.reaction = -1
                                responseData.response[index] = element
                            }
                            this.dataSourcePhone.data = responseData.response
                        } else {
                            this.snackbarData.description = responseData.msg
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            } catch {
                this.snackbarData.description = 'No se pudo cargar la información. Intente de nuevo.'
                this.snackbarData.openSnackbar = true
            } finally {
                this.dialogAceptPhones.loading = false
            }
        },
        changeReaction: function (item) {
            let arrPhones = this.dataSourcePhone.data
            for (let itemPhone of arrPhones) {
                if (itemPhone.reaction === 0 && item.numero_tel !== itemPhone.numero_tel && item.reaction === 0) {
                    itemPhone.reaction = -1
                }
            }
        },
        createTelephoneByClient: async function () {
            this.dialogAceptPhones.loading = true

            const PHONE = this.dialogAceptPhones.phone.toString().trim()
            const formData = new FormData();
            formData.append("telefono", await EncryptService.encrypt(PHONE));
            formData.append("id_cliente", await EncryptService.encrypt(this.idClient));

            await ManagementsService.createTelephoneByClient(formData).then(
                async (responseData) =>{
                    if (!responseData.error) {
                        this.snackbarData.description = '¡Registro Exitoso!'
                        this.snackbarData.openSnackbar = true
                        this.dialogAceptPhones.phone = null
                        this.isLoading = true
                        await this.getTelephonesByClient()
                        this.isLoading = false
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.dialogAceptPhones.loading = false
        },
        cancelConfirmate: function () {
            let arrPhone = this.dataSourcePhone.data
            for (let element of arrPhone) {
                element.reaction = -1
            }
            this.dialogAceptPhones.loading = false
            this.dialogAceptPhones.phone = null
            this.dialogAceptPhones.open = false
            this.dialogConfirmate.loading = false
            this.dialogConfirmate.open = false
        },

        confirmateFormPhones: function () {
            this.dialogAceptPhones.open = false

            this.dialogConfirmate.open = true
        },

        saveGestion: async function () {
            try {
                this.dialogConfirmate.loading = true
                let hasError = false

                let arrPhones = []
                for (let index = 0; index < this.dataSourcePhone.data.length; index++) {
                    let element = this.dataSourcePhone.data[index]
                    if (element.reaction === 0) {
                        const ENC_PHONE = await EncryptService.encrypt(element.numero_tel)
                        this.telephoneManagement = ENC_PHONE;
                        arrPhones.push({
                            numero_tel: ENC_PHONE,
                            prioridad: true
                        })
                    } else if (element.reaction === 1) {
                        const ENC_PHONE = await EncryptService.encrypt(element.numero_tel)
                        arrPhones.push({
                            numero_tel: ENC_PHONE,
                            prioridad: false
                        })
                    }
                }
                await ManagementsService.processLikesandDislikes({"telefonos": arrPhones}).then(
                    async (responseData) =>{
                        if (!responseData.error) {
                            this.snackbarData.description = "¡Registro de reacciones exitosa!"
                            this.snackbarData.openSnackbar = true
                        } else {
                            this.snackbarData.description = responseData.msg
                            this.snackbarData.openSnackbar = true
                            hasError = true
                        }
                    }
                )

                if (hasError) {
                    this.cancelConfirmate()
                    return;
                }

                const ID = localStorage.getItem('ID')
                const ENC_USERNAME = localStorage.getItem('USERNAME')
                const USERNAME = await EncryptService.decrypt(ENC_USERNAME)

                let id_usuario = ID
                id_usuario = await EncryptService.encrypt(id_usuario.toString())

                let id_cliente = this.idClient
                id_cliente = await EncryptService.encrypt(id_cliente.toString())

                let titular_aval = this.formGroup.data.titular_aval.toString()
                titular_aval = await EncryptService.encrypt(titular_aval.toString())

                let colaborador_gestion = this.formGroup.data.colaborador
                if (colaborador_gestion !== null && colaborador_gestion !== undefined) {
                    colaborador_gestion = await EncryptService.encrypt(colaborador_gestion.toString())
                } else {
                    colaborador_gestion = null
                }

                let colaborador_convenio = this.formGroup.data.colaborador_convenio
                if (colaborador_convenio !== null && colaborador_convenio !== undefined) {
                    colaborador_convenio = await EncryptService.encrypt(colaborador_convenio.toString())
                } else {
                    colaborador_convenio = null
                }
                
                let fecha_gestion = this.formGroup.data.fecha_gestion
                let hora_gestion = this.formGroup.data.hora_gestion
                hora_gestion = `${hora_gestion}:00`
                let observaciones = this.formGroup.data.observaciones
                let username = USERNAME
                let codigo_accion = this.formGroup.data.codigo_accion
                let codigo_resultado = this.formGroup.data.codigo_resultado
                let convenio_realizado = this.formGroup.data.convenio_realizado
                let deuda_total_original = this.infoClient.total
                let pago_inicial = this.formGroup.data.pago_inicial
                let fecha_convenio = this.formGroup.data.fecha_convenio
                let saldo_plan = this.formGroup.data.saldo_plan
                let tipo_pago = this.formGroup.data.opcionesPago
                let opciones_pago = tipo_pago == 'LIQUIDACION' ? 0 : this.formGroup.data.opciones_pago


                if (this.catalogConfigError || this.isLoadingCodeResult ||
                    (this.catalogSettings.dictamen_mode === 'result_one_to_one' && !this.derivedDictamen) ||
                    (this.catalogSettings.dictamen_mode === 'independent' && !this.formGroup.data.id_dictamen)) {
                    this.snackbarData = { openSnackbar: true, description: 'Revise la configuración y el dictamen antes de guardar.' };
                    this.dialogConfirmate.loading = false;
                    return;
                }
                const FORMDATA_CONVENIO = {
                    id_usuario: id_usuario,
                    id_cliente: id_cliente,
                    titular_aval: titular_aval,
                    fecha_gestion: fecha_gestion,
                    hora_gestion: hora_gestion,
                    observaciones: observaciones,
                    username: username,
                    colaborador_gestion: colaborador_gestion,
                    codigo_accion: codigo_accion,
                    codigo_resultado: codigo_resultado,
                    id_dictamen: this.formGroup.data.id_dictamen,
                    convenio_realizado: convenio_realizado,
                    deuda_total_original: deuda_total_original,
                    pago_inicial: pago_inicial,
                    fecha_convenio: fecha_convenio,
                    saldo_plan: saldo_plan,
                    opciones_pago: opciones_pago,
                    tipo_pago:tipo_pago,
                    colaborador_convenio: colaborador_convenio,
                    telefono_gestion: this.telephoneManagement,
                }

                await ManagementsService.saveManagement(FORMDATA_CONVENIO).then(
                    async (responseData) => {
                        if (responseData.error === false && !responseData.errors) {
                            this.snackbarData.description = `¡Registro exitoso!`
                            this.snackbarData.openSnackbar = true
                            this.cancelConfirmate()
                            const encForm = this.$route.params.form;
                            const targetUrl = `/SGCCV/access-search-management/${encForm}/general`;
                            this.$router.push(targetUrl);
                        } else {
                            this.snackbarData.description = typeof responseData.msg === 'string' ? responseData.msg : Object.values(responseData.msg || responseData.errors || {}).flat().join(' ') || responseData.message
                            this.snackbarData.openSnackbar = true
                            this.cancelConfirmate()
                        }
                    }
                )
                
                this.dialogConfirmate.loading = false

            } catch (error) {
                this.cancelConfirmate()
                this.snackbarData.description = `Ocurrió un error al registrar la gestión`
                this.snackbarData.openSnackbar = true
            }
        },

        valdiateForm: function() {
            let isValid = false;
            for (const iterator of this.dataSourcePhone.data) {
                if (iterator.reaction === 0) {
                    isValid = true;
                }
            }
            return isValid;
        },

        llenarSelectPlazos: function(){
            this.arrOptionPay = [];
            this.formGroup.data.opciones_pago = '';
            this.isDisabledSelectPlazos = true;
            this.formGroup.data.fecha_convenio = null;

            if(this.formGroup.data.opcionesPago == 'SEMANAL'){
                for (let index = 1; index < 53; index++) {
                    let valueOption = ''
                    if (index == 1) {
                        valueOption = index + ' ' + "semana";
                    } else {
                        valueOption = index + ' ' + "semanas";
                    }
                    this.arrOptionPay.push({ key: index, value: valueOption });
                    this.isDisabledSelectPlazos = false
                }
            }
            
            if(this.formGroup.data.opcionesPago == 'MENSUAL'){
                for (let index = 1; index < 13; index++) {
                    let valueOption = ''
                    if (index == 1) {
                        valueOption = index + ' ' + "mes";
                    } else {
                        valueOption = index + ' ' + "meses";
                    }
                    this.arrOptionPay.push({ key: index, value: valueOption });
                    this.isDisabledSelectPlazos = false
                }
            }
            
            if(this.formGroup.data.opcionesPago == 'QUINCENAL'){
                for (let index = 1; index < 25; index++) {
                    let valueOption = ''
                    if (index == 1) {
                        valueOption = index + ' ' + "quincena";
                    } else {
                        valueOption = index + ' ' + "quincenas";
                    }
                    this.arrOptionPay.push({ key: index, value: valueOption });
                    this.isDisabledSelectPlazos = false
                }
            }
        },
        getLastDayOfMonth(year, monthIndex /* 0-11 */) {
            const lastDay = new Date(year, monthIndex + 1, 0).getDate();

            // Si es febrero → respeta 28 o 29
            if (monthIndex === 1) {
                return lastDay; // febrero
            }

            // En cualquier otro mes, limita a 30 días
            return lastDay > 30 ? 30 : lastDay;
        },
        isQuincenal() {
            return this.formGroup.data.opcionesPago === 'QUINCENAL';
        },
        isAllowedDate(iso) {
            // iso: 'YYYY-MM-DD'
            if (!iso) return true; // sin valor, deja que otras rules actúen
            const [yyyy, mm, dd] = iso.split('-').map(Number);
            if (!yyyy || !mm || !dd) return false;

            const last = this.getLastDayOfMonth(yyyy, mm - 1); // 28/29/30/31
            // Reglas quincenales: 15 y último día del mes
            const allowedDays = new Set([15, last]);
            return allowedDays.has(dd);
        },
        onFechaChange() {
            // Dispara cuando el usuario selecciona algo en el calendario nativo
            this.validarActual(true);
        },
        validarActual(clearIfInvalid = false) {
            const v = this.formGroup.data.fecha_convenio;

            if (!this.isQuincenal()) {
                // Si NO es quincenal, no restringimos nada
                this.fechaError = '';
                return true;
            }

            if (this.isAllowedDate(v)) {
                this.fechaError = '';
                return true;
            }

            // Mensaje claro (incluye excepción de febrero implícita por "último día del mes")
            this.fechaError = 'Para pago quincenal solo se permite el día 15 o el último día del mes.';
            if (clearIfInvalid) {
                // Limpia la fecha inválida para obligar a corregir
                this.formGroup.data.fecha_convenio = '';
            }
            return false;
            },
            // Regla extra que puedes inyectar en :rules del text-field
            validateFechaQuincenal: function (value) {
            if (!this.isQuincenal()) return true;
            return this.isAllowedDate(value) || 'Para pago quincenal solo se permite el día 15 o el último día del mes.';
        },
        
    }
}
</script>

<style scoped>
    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 12pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
    
    .container_submenu {
        height: calc(100% - 50px);
        overflow: auto;
        margin-bottom: 30px;
    }

    .content_information {
        display: flex; 
        flex-wrap: wrap; 
        flex-direction: row;
    }
    .item_icon {
        display: flex; 
        justify-content: center; 
        align-items: center; 
        width: 60px;
    }
    .item_data {
        display: flex; 
        flex-direction: column; 
        flex-grow: 1; 
        overflow: hidden; 
        width: calc(100% - 60px)
    }
    .data_title {
        font-size: 9pt;
        font-weight: 600;
    }
    .data_info {
        font-size: 16pt; 
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis;
    }

    .item_info_25 {
        display: flex; 
        flex-direction: row; 
        padding: 20px; 
        width: 25%;
    }
    .item_info_33 {
        display: flex; 
        flex-direction: row; 
        padding: 20px; 
        width: calc(100% / 3);
    }

    @media all and (max-width: 1200px) {
        .item_info_25 {
            display: flex; 
            flex-direction: row; 
            padding: 20px; 
            width: calc(100% / 3);
        }
        .item_info_33 {
            display: flex; 
            flex-direction: row; 
            padding: 20px; 
            width: calc(100% / 3);
        }
    }
    @media all and (max-width: 900px) {
        .item_info_25 {
            display: flex; 
            flex-direction: row; 
            padding: 20px; 
            width: calc(100% / 2);
        }
        .item_info_33 {
            display: flex; 
            flex-direction: row; 
            padding: 20px; 
            width: calc(100% / 2);
        }
    }
    @media all and (max-width: 600px) {
        .item_info_25 {
            display: flex; 
            flex-direction: row; 
            padding: 20px; 
            width: 100%;
        }
        .item_info_33 {
            display: flex; 
            flex-direction: row; 
            padding: 20px; 
            width: 100%;
        }
    }


    .container_time {
        width: 100%; 
        display: flex; 
        flex-direction: row; 
        flex-wrap: wrap;
    }

    .item_time {
        width: calc(100%  / 3); 
        display: flex; 
        flex-direction: column;
    }

    .time_button {
        display: flex; 
        align-items: center; 
        justify-content: center; 
        margin-right: 6px;
    }

    .item_data_time {
        width: calc(100% - 5px);
    }

    .separate_time {
        width: 5px; 
        font-size: 26pt; 
        margin-right: 6px;
    }

</style>